import { Placeholder, PlaceholderLine, PlaceholderMedia, ShineOverlay } from 'app/overrides/rn-placeholder';
import { type ViewProps } from 'react-native-svg/lib/typescript/fabric/utils';
import { OFFER_CARD_HEIGHT, OFFER_CARD_WIDTH } from './listing-offer-card';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export function ListingCardSkeleton() {
  const leftView = (props: ViewProps) => (
    <PlaceholderMedia
      style={[
        {
          height: OFFER_CARD_HEIGHT,
          width: OFFER_CARD_WIDTH,
          borderRadius: theme.borderRadii['radius.lg'],
        },
        props.style,
      ]}
    />
  );
  return (
    <Placeholder Animation={ShineOverlay} Left={leftView}>
      <PlaceholderLine style={{ width: 140, marginBottom: 20 }} />
      <PlaceholderLine style={{ width: 50, marginBottom: 40 }} />

      <PlaceholderLine style={{ width: 120, height: 30, borderRadius: theme.borderRadii['radius.lg'] }} />
    </Placeholder>
  );
}
